import { Action, createReducer, on } from '@ngrx/store';
import * as blogActions from '../action/blog.action';
import { BlogModel } from '../model/blog.model';

export interface BlogState {
    blog: BlogModel,
    isDownloading: boolean,
    isDownloadingSuccess: boolean,
    isDownloadingFailure: boolean,
    error: string
}

export const initialState: BlogState = {
    blog: {} as BlogModel,
    isDownloading: false,
    isDownloadingSuccess: false,
    isDownloadingFailure: false,
    error: ''
};

const blogReducer = createReducer(
    initialState,
    on(blogActions.blog, () =>
    ({
        blog: {} as BlogModel,
        isDownloading: true,
        isDownloadingSuccess: false,
        isDownloadingFailure: false,
        error: ''
    })),
    on(blogActions.blogSuccess, (_, response) =>
    ({
        blog: response.blog,
        isDownloading: false,
        isDownloadingSuccess: true,
        isDownloadingFailure: false,
        error: ''
    })),
    on(blogActions.blogFailure, (state, response) =>
    ({
        blog: state.blog,
        isDownloading: false,
        isDownloadingSuccess: false,
        isDownloadingFailure: true,
        error: response.error
    })),
    on(blogActions.blogLoadMore, () =>
    ({
        blog: {} as BlogModel,
        isDownloading: true,
        isDownloadingSuccess: false,
        isDownloadingFailure: false,
        error: ''
    })),
    on(blogActions.blogLoadMoreSuccess, (_, response) =>
    ({
        blog: response.blog,
        isDownloading: false,
        isDownloadingSuccess: true,
        isDownloadingFailure: false,
        error: ''
    })),
    on(blogActions.blogLoadMoreFailure, (state, response) =>
    ({
        blog: state.blog,
        isDownloading: false,
        isDownloadingSuccess: false,
        isDownloadingFailure: true,
        error: response.error
    }))
)

export function blog(
    state: BlogState | undefined,
    action: Action
): BlogState {
    return blogReducer(state, action);
}
